const form_data = (values) => {
    let formData = new FormData();
    for (let key in values) {
        const value = values[key];
        // 避免把 JS 的 undefined/null 变成字符串 "undefined"/"null" 导致后端 500
        if (value === undefined || value === null) {
            formData.append(`${key}`, '');
        } else {
            formData.append(`${key}`, `${value}`);
        }
    }
    return formData
}

export default form_data;
